import React, {FunctionComponent, useEffect} from 'react'
import styles from './StatisticsPage.module.sass'
import {useRootDispatch, useRootSelector} from '../../../utils/hooks'
import RequestDropdown from '../../data-components/dropdowns/RequestDropdown/RequestDropdown'
import {apiRequests} from '../../../http/config'
import {User} from '../../../responses/users'
import Spacer from '../../etc/Spacer'
import clsx from 'clsx'
import {Classes} from '../../../styles'
import Button from '../../controls/Button/Button'
import DownloadIcon from '../../../../files/download.svg'
import {byManagerActions} from '../../../redux/pages/statistics/byManager'
import {getId} from '../../../utils/entity-utils'
import StatisticsTable from './StatisticsTable/StatisticsTable'
import {isSome} from 'fp-ts/Option'
import {ColumnConfiguration} from './StatisticsTable/configuration'
import {ByManagerData} from '../../../responses/statistics'
//import {toBool} from '../../../utils/utils'
import {flow} from 'fp-ts/function'
import {toServerDate} from '../../../utils/date-utils'
import {fst, snd} from 'fp-ts/Tuple'
import ColumnPicker from './ColumnPicker/ColumnPicker'
import {NonEmptyArray} from 'fp-ts/NonEmptyArray'
import FiltersClearIcon from '../../../../files/filters-clear.svg'
import {RequestStatus} from '../../../responses/response'
import TopBarProgress from 'react-topbar-progress-indicator'
import {isDefinedTuple} from '../../../utils/utils'

const configuration: NonEmptyArray<ColumnConfiguration<ByManagerData>> = [{
    group: '',
    name: '',
    render: data => data.name
},{
    group: 'Проекты',
    name: 'Открыто',
    render: data => data.total.projects.opened ?? 0,
}, {
    group: 'Проекты',
    name: 'Закрыто',
    render: data => data.total.projects.closed ?? 0,
}, {
    group: 'Проекты',
    name: 'Отменено',
    render: data => data.total.projects.canceled ?? 0,
}, {
    group: 'Объекты',
    name: 'Открыто',
    render: data => data.total.project_work_objects.opened ?? 0,
}, {
    group: 'Объекты',
    name: 'Закрыто',
    render: data => data.total.project_work_objects.closed ?? 0,
}, {
    group: 'Дизайн',
    name: 'Выиграно',
    render: data => data.total.project_work_objects.design.won ?? 0,
}, {
    group: 'Дизайн',
    name: 'Проиграно',
    render: data => data.total.project_work_objects.design.lost ?? 0,
}, {
    group: 'Дизайн',
    name: 'Отменено',
    render: data => data.total.project_work_objects.design.canceled ?? 0,
}, {
    group: 'Производство',
    name: 'Выиграно',
    render: data => data.total.project_work_objects.production.won ?? 0,
}, {
    group: 'Производство',
    name: 'Проиграно',
    render: data => data.total.project_work_objects.production.lost ?? 0,
}, {
    group: 'Производство',
    name: 'Отменено',
    render: data => data.total.project_work_objects.production.canceled ?? 0,
}, {
    group: 'Задачи',
    name: 'Открыто',
    render: data => data.total.tasks.opened ?? 0,
}, {
    group: 'Задачи',
    name: 'Закрыто',
    render: data => data.total.tasks.closed ?? 0,
}]

const ManagerTab: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const {data, hide, open, sort, users, managers, state} = useRootSelector(state => state.pages.statistics.byManager)
    const { brands, clients, date} = useRootSelector(state => state.pages.statistics.byClient)

    useEffect(() => {
        if (isDefinedTuple(date)) {
            dispatch(byManagerActions.data.request({
                managers: managers.map(getId),
                users: users.map(getId),
                //compare: toBool(periods),
                brands: brands.map(getId),
                clients: clients.map(getId),
                date_from: toServerDate(fst(date)),
                date_to: toServerDate(snd(date)),
            }))
        }
    }, [dispatch, managers, users, brands, clients, date])

    return <div className={styles.content}>
        {
            state === RequestStatus.FETCHING && <TopBarProgress/>
        }
        <div className={styles.header}>
            <RequestDropdown<User>
                className={styles.dropdown}
                placeholder={'Менеджер'}
                type={'multi'}
                value={managers}
                onChange={managers => dispatch(byManagerActions.setManagers(managers))}
                request={query => apiRequests.dictionary.list({
                    params: {key: 'manager'},
                    query
                })}
                render={user => user.name}
            />
            <RequestDropdown<User>
                className={styles.dropdown}
                placeholder={'Исполнитель'}
                render={user => user.name}
                request={query => apiRequests.project.tip({
                    params: {key: 'tasks_target_user'},
                    query
                })}
                type={'multi'}
                onChange={users => dispatch(byManagerActions.setUsers(users))}
                value={users}
            />
            <Button
                title={'Очистить фильтры'}
                onClick={() => dispatch(byManagerActions.clearFilters())}
            >
                <FiltersClearIcon/>
            </Button>
            <Spacer/>
            <div className={clsx(styles.text, Classes.f9)}>
                <div>Для выгрузки в Excel выберите столбцы,</div>
                <div>Менеджера и соответствующих Исполнителей.</div>
            </div>
            <ColumnPicker hide={hide} config={configuration} onChange={flow(byManagerActions.setHiddenColumns, dispatch)}/>
            <Button title={'Скачать в формате Excel'}>
                <DownloadIcon/>
            </Button>
        </div>
        {
            isSome(data) && <StatisticsTable
                name={'Менеджер'}
                data={data.value}
                config={configuration}
                hide={hide}
                open={open}
                sort={sort}
                onSortChange={flow(byManagerActions.setSort, dispatch)}
                onRowToggle={flow(byManagerActions.toggleRow, dispatch)}
            />
        }
    </div>
}

export default ManagerTab